export default {
  getOrderList: '/courier/api/v2/my/order/list',
  orderConfig: '/v2/shansongconfig/order/config'
}
